module.exports = __webpack_public_path__ + "static/media/customer-icon-footer.ea1b66f7.svg";